<template>
  <div class="main">
    <el-button type="primary" class="exitBtn" @click="exitClick">退出</el-button>
    <el-button type="success" class="exportBtn" @click="exportClick" v-show="exportBtnIsShow">导出报告</el-button>
    <div id="pdfDom" class="display">
      <div class="header">
        <img src="../../assets/red.png">
        <h3>{{reportInfo.hospitalName}}</h3>
      </div>
      <h4 style="text-align: center">超声医学影像报告单</h4>
      <div><span class="value">检查部位：</span><span class="label">{{patientInfo.presetName}}</span></div>
      <el-divider />
      <div class="patient-info">
        <div class="patient-info-item-first">
          <span class="value">姓名：</span><span class="label">{{patientInfo.name}}</span>
        </div>
        <div class="patient-info-item-first">
          <span class="value">性别：</span><span class="label">{{patientInfo.sex}}</span>
        </div>
        <div class="patient-info-item-first">
          <span class="value">年龄：</span><span class="label">{{patientInfo.age}}</span>
        </div>
        <div class="patient-info-item-first">
          <span class="value">科室：</span><span class="label">{{patientInfo.departmentName}}</span>
        </div>
      </div>
      <el-divider />
      <div class="imageDisplay">
        <ul>
          <li v-for="(item, index) in selectedList" :key="index">
            <img :src="item" crossorigin="anonymous"/>
          </li>
        </ul>
      </div>
      <el-divider />
      <div class="image-perf">
        <h4 class="value">影像学表现：</h4>
        <p>{{reportInfo.imagePerformance}}</p>
      </div>
      <el-divider />
      <div class="imge-conclusion">
        <h4 class="value">影像学结论：</h4>
        <p>{{reportInfo.imageConclusion}}</p>
      </div>
      <el-divider />
      <div class="patient-info">
        <div class="patient-info-item">
          <span class="value-bottom">医院名字：</span><span class="label-bottom">{{reportInfo.hospitalName}}</span>
        </div>
        <div class="patient-info-item">
          <span class="value-bottom">诊断医师：</span>
          <el-image
            class="sign"
            style="width: 100px; height: 40px"
            :src="reportInfo.signUrl"
            fit="fit"
            @load="signFinish">
          </el-image>
        </div>
        <div class="patient-info-item">
          <span class="value-bottom">检查日期：</span><span class="label-bottom">{{reportInfo.cheackDate}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsUtill from '../utils/JsUtill'
import {getReportDetail} from '../../request/api'

export default {
  name: 'ProduceReport',
  props: ['orderSn', 'departmentList', 'presetList'],
  data () {
    return {
      patientInfo: {
        name: '',
        sex: '',
        age: '',
        departmentName: '',
        presetName: ''
      },
      reportInfo: {
        imagePerformance: '',
        imageConclusion: '',
        cheackDate: '',
        hospitalName: '',
        signUrl: ''
      },
      selectedList: [],
      exportBtnIsShow: false
    }
  },
  mounted () {
    this.renderPage()
  },
  methods: {
    exitClick () {
      this.$router.push({'name': 'Home', params: {type: 2}})
    },
    signFinish (e) {
      this.exportBtnIsShow = true
    },
    exportClick () {
      // 这里$nextTick的作用是当整个页面渲染完成以后才会调用后续方法
      this.$nextTick(() => { this.getPdf(this.patientInfo.name, this.orderSn) })
    },
    renderPage () {
      let that = this
      getReportDetail({
        orderSn: that.orderSn
      }).then(response => {
        if (response.code === 1000) {
          that.patientInfo.name = response.data.name
          if (response.data.sex === 0) {
            that.patientInfo.sex = '女'
          } else {
            that.patientInfo.sex = '男'
          }
          that.patientInfo.age = response.data.age
        } else {
          this.$message.error('请求数据失败')
        }
        for (let item of that.departmentList) {
          if (item.value === response.data.departmentId) {
            that.patientInfo.departmentName = item.label
          }
        }
        for (let item of that.presetList) {
          if (item.value === response.data.presetId) {
            that.patientInfo.presetName = item.label
          }
        }
        that.selectedList = response.data.imageUrl.split(',')
        that.reportInfo.imagePerformance = response.data.imagePerformance
        that.reportInfo.imageConclusion = response.data.imageConclusion
        that.reportInfo.cheackDate = JsUtill.methods.getTime(response.data.createDate)
        that.reportInfo.hospitalName = response.data.hospitalName
        that.reportInfo.signUrl = response.data.signUrl
      })
    }
  }
}
</script>

<style scoped>
.main {
  height: 100%;
}
.display {
  background-color: #fff;
  padding: 20px;
  width: 210mm;
  margin: 0 auto;
}
.display h1 {
  font-size: 35px;
  display: inline-block;
}
.display h3 {
  margin: 10px 0;
  text-align: center;
  font-size: 25px;
}
.value {
  font-size: 15px;
  font-weight: bold;
}
.label {
  font-size: 15px;
}
.el-divider {
  height: 3px;
  background-color: black;
}
.patient-info {
  display: flex;
}
.patient-info-item {
  line-height: 40px;
  flex: 1;
}
.patient-info-item-first {
  line-height: 10px;
  flex: 1;
}
.imageDisplay {
}
.imageDisplay ul {
  padding: 0px;
  text-align: center;
}
.imageDisplay li {
  position: relative;
  list-style: none;
  display: inline-block;
  width: 200px;
  height: 280px;
  margin: 0 10px;
  overflow: hidden;
}
.imageDisplay img {
  margin-top: -40px;
  width: 100%;
}
.image-perf {
  height: 150px;
}
.imge-conclusion {
  height: 150px;
}
.header {
  width: 100%;
  display: inline-block;
  text-align: center;
  position: relative;
}
.header img {
  position: absolute;
  left: 0px;
  width: 10%;
}
.value-bottom {
  font-size: 15px;
  font-weight: bold;
  vertical-align: middle;
}
.label-bottom {
  font-size: 15px;
  vertical-align: middle;
}
.sign {
  vertical-align: middle;
}
.exportBtn {
  top: 20px;
  left: 120px;
  position: fixed;
}

.exitBtn {
  top: 20px;
  left: 20px;
  position: fixed;
}

</style>



// WEBPACK FOOTER //
// src/components/report/ProduceReport.vue